<template>
  <div class="tgh-residential-details">
    <router-link to="/commercial" class="tgh-close-rd">
      <img src="../assets/images/close.png" alt="">
    </router-link>
    <hooper>
      <slide>
        <div class="tgh-rd-starter">
          <img :src="collaborator.photo" alt="">
          <div class="tgh-rds-detail">
            <h1>{{ collaborator.title }}</h1>
            <p v-html="collaborator.description"></p>
          </div>
        </div>
      </slide>
      <slide v-for="(colab,colabIndex) in collaborator.images" :key="`colab-im-${colabIndex}`">
        <div class="tgh-rd-images">
          <img :src="colab.photo" alt="">
        </div>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
} from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: 'CollaboratorsDetails',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data() {
    return {
      collaborator : []  
    }
  },
  methods : {
    getData(){
      let vm = this
      let url = apiUrl+'/commercial/get'
      let data = {
        id : this.$route.params.col
      }
      axios.post(
          url,
          data
      )
      .then(response => {
          if(response.data.status){
              vm.collaborator = response.data.data
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    }
  },
  mounted() {
    this.getData()
    this.$store.commit('goFullScreen')
  },
  destroyed() {
    this.$store.commit('exitFullScreen')
  }
}
</script>
